// We need to use the same sorting algorithm that react-table uses in some places, but there aren't
// type definitions for it. Rather than implementing or importing another one, it is copy/pasted
// here.

/* eslint-disable no-restricted-globals */
/* eslint-disable no-continue */
/* eslint-disable @typescript-eslint/no-explicit-any */

// Code below is copied from: https://github.com/tannerlinsley/react-table/blob/127a7fca8754f6289b6bc019dbd1fc4bcdd13187/src/sortTypes.js
const reSplitAlphaNumeric = /([0-9]+)/gm;

function toString(a: any): string {
    if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) {
            return '';
        }

        return String(a);
    }
    if (typeof a === 'string') {
        return a;
    }

    return '';
}

// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
export const sortAlphanumeric = (A: any, B: any): number => {
    // Force to strings (or "" for unsupported types)
    const stringA = toString(A);
    const stringB = toString(B);

    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = stringA.split(reSplitAlphaNumeric).filter(Boolean);
    const b = stringB.split(reSplitAlphaNumeric).filter(Boolean);

    // While
    while (a.length && b.length) {
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa ?? '0', 10);
        const bn = parseInt(bb ?? '0', 10);

        const combo = [an, bn].sort();

        // Both are string
        if (isNaN(combo[0])) {
            if ((aa ?? 0) > (bb ?? 0)) {
                return 1;
            }
            if ((bb ?? 0) > (aa ?? 0)) {
                return -1;
            }

            continue;
        }

        // One is a string, one is a number
        if (isNaN(combo[1])) {
            return isNaN(an) ? -1 : 1;
        }

        // Both are numbers
        if (an > bn) {
            return 1;
        }
        if (bn > an) {
            return -1;
        }
    }

    return a.length - b.length;
};
